import { Box, Container, Grid } from '@mui/material';
import React from 'react';
import { Route, Routes, matchPath, useLocation } from 'react-router-dom';
import { useI18n } from '@haohan/root-locales';
import { SiteRouterLink } from '../components/RouterLink';
import { makeStyles } from 'tss-react/mui';
import { AppStoreContext } from '../AppStore';

const MySettings = React.lazy(
	() => import(
		/* webpackChunkName: "my-settings" */
		'./views/Settings'
	).then(m => ({default: m.MySettings}))
);

const MyDocuments = React.lazy(
	() => import(
		/* webpackChunkName: "my-settings" */
		'./views/Documents'
	).then(m => ({default: m.MyDocuments}))
);

const MyGames = React.lazy(
	() => import(
		/* webpackChunkName: "my-games" */
		'./views/Games'
	).then(m => ({default: m.MyGames}))
);

const GameCreate = React.lazy(
	() => import(
		/* webpackChunkName: "game-create" */
		'./views/GameCreate'
	).then(m => ({default: m.GameCreate}))
);

const GameItem = React.lazy(
	() => import(
		/* webpackChunkName: "game-item" */
		'./views/GameItem'
	).then(m => ({default: m.GameItem}))
);

const useStyles = makeStyles()(theme => {
    return {
        menuItem: {
            position: 'relative',
            display: 'block',
            marginBottom: 12,
            paddingLeft: 8,
            lineHeight: 1.25,
            color: theme.palette.text.secondary,
            '&:after': {
                content: "''",
                position: 'absolute',
                display: 'none',
                left: 0,
                top: 0,
                bottom: 0,
                width: 1,
                backgroundColor: theme.palette.text.primary
            },
            '&:hover': {
                color: theme.palette.text.primary,
                '&:after': {
                    display: 'block',
                }
            }
        },
        menuItemActive: {
            color: theme.palette.primary.main,
            '&:after': {
                display: 'block',
                backgroundColor: theme.palette.primary.main
            }
        }
    };
});

export const MyRoot: React.FC = props => {
    const { t, lang } = useI18n();
    const { classes, cx } = useStyles();
    const location = useLocation();
    const menu: {
        title: string,
        to: string,
        el: React.ReactNode
    }[] = [
        {
            title: t('Documents'),
            to: 'documents/:folderID',
            el: <MyDocuments/>
        },
        {
            title: t('Account settings'),
            to: 'settings',
            el: <MySettings />
        },
    ];
    const app = React.useContext(AppStoreContext);
    React.useEffect(() => {
        if (!app.activeUser) {
            window.location.href = "/";
        }
    }, [app.activeUser])
    if (typeof document === 'undefined') {
        return null;
    }
    return (
        <Box mt={6}>
            <Container>
                <Grid
                    container
                    spacing={6}
                    // direction='row-reverse'
                >
                    <Grid item flex={1}>
                        <Routes>
                            <Route
                                index
                                path="documents/:folderID?"
                                element={
                                    <React.Suspense>
                                        <MyDocuments/>
                                    </React.Suspense>
                                }   
                            />
                            <Route
                                path="game/create/"
                                element={
                                    <React.Suspense>
                                        <GameCreate/>
                                    </React.Suspense>
                                }   
                            />

                            <Route
                                path="games/"
                                element={
                                    <React.Suspense>
                                        <MyGames/>
                                    </React.Suspense>
                                }   
                            />

                            <Route
                                path="game/:publicHash/view"
                                element={
                                    <React.Suspense>
                                        <GameItem/>
                                    </React.Suspense>
                                }   
                            />
                            
                            <Route
                                index
                                path="*"
                                element={
                                    <React.Suspense>
                                        <MySettings/>
                                    </React.Suspense>
                                }   
                            />
                            
                            {/* <Route
                                index
                                path="games"
                                element={
                                    <React.Suspense>
                                        <MyGames/>
                                    </React.Suspense>
                                }   
                            /> */}
                        </Routes>
                    </Grid>
                    {/* <Grid item>
                        {menu.map(item => {
                            const isActive = Boolean(
                                matchPath(
                                    {
                                        path: `/${lang}/my/${item.to}`,
                                        end: false
                                    },
                                    location.pathname,
                                )
                            );
                            return (
                                <SiteRouterLink
                                    to={`my/${item.to}`}
                                    key={item.to}
                                    className={cx(classes.menuItem, {
                                        [classes.menuItemActive]: isActive
                                    })}
                                    underline='none'
                                    fontWeight={500}
                                    fontSize={13}
                                >
                                    {item.title}
                                </SiteRouterLink>
                            );
                        })}
                    </Grid> */}
                </Grid>
            </Container>
        </Box>
    );
}
